export default __webpack_public_path__ + "static/media/slide23.57b8ae96.png";